import React from 'react';
import { X, CheckCircle, AlertCircle, Info, XCircle } from 'lucide-react';

const MessageModal = ({ message, type, onClose }) => {
  if (!message) return null;

  const getIcon = () => {
    switch (type) {
      case 'success': return <CheckCircle className="h-8 w-8 text-green-500" />;
      case 'error': return <XCircle className="h-8 w-8 text-red-500" />;
      case 'warning': return <AlertCircle className="h-8 w-8 text-yellow-500" />;
      default: return <Info className="h-8 w-8 text-blue-500" />;
    }
  };

  const getColors = () => {
    switch (type) {
      case 'success': return 'from-green-500 to-emerald-600';
      case 'error': return 'from-red-500 to-pink-600';
      case 'warning': return 'from-yellow-500 to-orange-600';
      default: return 'from-blue-500 to-purple-600';
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 animate-fade-in">
      <div className="bg-white rounded-3xl p-8 max-w-md mx-4 shadow-2xl animate-bounce-in">
        <div className="flex justify-between items-start mb-6">
          <div className={`p-3 rounded-2xl bg-gradient-to-r ${getColors()}`}>
            {getIcon()}
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 p-2 hover:bg-gray-100 rounded-full transition-all duration-200"
          >
            <X className="h-6 w-6" />
          </button>
        </div>
        
        <div className="text-center">
          <h3 className="text-xl font-bold text-gray-900 mb-3">
            {type === 'success' && '🎉 Success!'}
            {type === 'error' && '❌ Error!'}
            {type === 'warning' && '⚠️ Warning!'}
            {type === 'info' && 'ℹ️ Information'}
          </h3>
          <p className="text-gray-600 text-lg leading-relaxed mb-6">
            {message}
          </p>
          <button
            onClick={onClose}
            className={`btn-primary bg-gradient-to-r ${getColors()} px-8 py-3`}
          >
            Got it! ✨
          </button>
        </div>
      </div>
    </div>
  );
};

export default MessageModal;